import { connect } from 'react-redux';
import { unsuggestUser } from './redux/actions';
import { getCurrentUserId } from '../publicSession/selectors';
const mapStateToProps = (state)=>({
        currentUserId: getCurrentUserId(state)
    });
const mapDispatchToProps = (dispatch)=>({
        unsuggestUser: (userid)=>dispatch(unsuggestUser({
                userid
            }))
    });
export default connect(mapStateToProps, mapDispatchToProps);

//# sourceMappingURL=WatchSuggestionList.container.js.map